enum PATHS {
  ROOT = '/',
  MESSAGE = 'message',
  HISTORY = 'history',
  TRANSLATIONS = 'translations',
}
export default PATHS;
